module.exports = __webpack_public_path__ + "img/QRcode.d86ad51b.png";